import { DeleteOutlined, EditOutlined, MoreOutlined } from "@ant-design/icons";
import { Button, Dropdown, Popconfirm, Table } from "antd";
import { EmptyState } from "@/shared/components/EmptyState";
import { StatusTag } from "@/shared/components/StatusTag";
import { useUrlTableState } from "@/shared/hooks/useUrlState";
import { formatTableIndex } from "@/shared/utils/formatTableIndex";
import { tablePagination } from "@/shared/utils/tablePagination";
import { useDeleteUser, useUsers } from "../hooks/useUsers";
import { useUsersStore } from "../store/users.store";
import type { User } from "../types";

export function UserTable() {
	const { onOpen } = useUsersStore();
	const { page: currentPage, limit: pageSize, setPage } = useUrlTableState();
	const { data, isLoading } = useUsers({ page: currentPage, limit: pageSize });
	const { mutate: deleteUser } = useDeleteUser();
	const items = data?.data?.items ?? [];
	const total = data?.data?.meta?.total ?? 0;

	return (
		<Table
			loading={isLoading}
			pagination={tablePagination({
				page: currentPage,
				limit: pageSize,
				total,
				onChange: (page, size) => setPage(page, size ?? pageSize),
			})}
			size="small"
			scroll={{ x: "max-content" }}
			dataSource={items}
			rowKey="id"
			locale={{
				emptyText: <EmptyState description="Foydalanuvchilar topilmadi" />,
			}}
			columns={[
				{
					key: "#",
					title: "#",
					width: 60,
					align: "center",
					render: (_, __, index) => formatTableIndex(currentPage, pageSize, index),
				},
				{
					key: "fullname",
					title: "Ism",
					dataIndex: "fullname",
					ellipsis: true,
				},
				{
					key: "phone",
					title: "Telefon",
					dataIndex: "phone",
					render: (phone: string) => <span className="font-mono">{phone}</span>,
				},
				{
					key: "isActive",
					title: "Holat",
					dataIndex: "isActive",
					width: 100,
					render: (isActive: boolean) => (
						<StatusTag tone={isActive ? "success" : "error"}>
							{isActive ? "Faol" : "Nofaol"}
						</StatusTag>
					),
				},
				{
					key: "actions",
					title: "Amallar",
					width: 80,
					align: "center",
					render: (_: unknown, record: User) => (
						<Dropdown
							menu={{
								items: [
									{
										key: "edit",
										icon: <EditOutlined />,
										label: "Tahrirlash",
										onClick: () => onOpen(record),
									},
									{
										key: "delete",
										danger: true,
										label: (
											// biome-ignore lint/a11y/useKeyWithClickEvents: dropdown menu item
											// biome-ignore lint/a11y/noStaticElementInteractions: dropdown menu item
											<div onClick={(e) => e.stopPropagation()}>
												<Popconfirm
													title="O'chirish"
													description="Rostdan ham o'chirmoqchimisiz?"
													onConfirm={() => deleteUser(record.id)}
													okText="Ha"
													cancelText="Yo'q"
													okButtonProps={{ danger: true }}
												>
													<div
														style={{
															width: "100%",
															display: "flex",
															alignItems: "center",
															gap: "8px",
														}}
													>
														<DeleteOutlined />
														<span>O&apos;chirish</span>
													</div>
												</Popconfirm>
											</div>
										),
									},
								],
							}}
							trigger={["click"]}
							placement="bottomRight"
						>
							<Button type="text" icon={<MoreOutlined />} size="small" />
						</Dropdown>
					),
				},
			]}
		/>
	);
}
